import { useSilentAwaken } from '~/utils/active/use-silent-awaken';
import { useAtomValue } from 'jotai';
import { FC, useEffect, useMemo } from 'react';
import { DeepLinkBuildingProps } from '~/utils/active/schema';
import { $CurrentPOIInfoAsAvailable, $CurrentPOIInfoOrNull } from '@poi/shared/current-poi-info';
import { $CurrentPOIPosts } from '@poi/shared/current-poi-posts';
import { buildDeepLink } from '~/utils/active';
import { $InstalledRelatedApp, $DOMReadyState, $UserAgent } from '@lemon8/web-app-shared/atom';

export const PoiSilentAwaken = () => {
  const poi = useAtomValue($CurrentPOIInfoAsAvailable);
  const { items, hasMore } = useAtomValue($CurrentPOIPosts);
  const hasFulfilled = useMemo(() => Boolean(items), [hasMore]);
  const schemaOption: DeepLinkBuildingProps = useMemo(() => {
    return { pid: 'sharing_install', pageType: 'poi', poiId: poi.id };
  }, []);

  useSilentAwaken({
    awakenOptions: { schemaOption },
    hasFulfilled,
  });
  return <></>;
};

export const PoiSilentAwakenV2: FC = () => {
  const { userAgent } = useAtomValue($UserAgent);
  const domReadyState = useAtomValue($DOMReadyState);
  const installedRelatedApp = useAtomValue($InstalledRelatedApp);
  const poi = useAtomValue($CurrentPOIInfoOrNull);

  useEffect(() => {
    if (domReadyState === 'complete' && /android/i.test(userAgent)) {
      try {
        let schemaOption: DeepLinkBuildingProps;
        if (!poi) {
          schemaOption = { pid: 'sharing_install', pageType: 'feed', categoryId: 0 };
        } else {
          schemaOption = {
            pid: 'sharing_install',
            pageType: 'poi',
            poiId: poi.id,
          };
        }

        location.href = buildDeepLink({ schemaOption });
      } catch (e) {
        console.error('error in silent awaken', e);
      }
    }
  }, [domReadyState, userAgent]);

  useEffect(() => {
    if (installedRelatedApp && installedRelatedApp !== 'pending') {
      window.Tea('wap_with_app', {
        installed_app_name: installedRelatedApp.id,
        installed_app_version: installedRelatedApp.version,
      });
    }
  }, [installedRelatedApp]);

  return null;
};
